// @flow
import { createSelector } from 'reselect';
import prop from 'ramda/es/prop';

import { tableColumnSort, tableColumnSortClass } from 'app/common/lib/sort';


/**
 * Селектор данных классов с учетом сортировки
 */

export type OutgoingProps = {
  idx: number,
  classTitle: string,
  data: Array<Object>,
  total: number,
  split1?: number,
  split2?: number,
}


type Selector = (state: Object, props: Object) => Array<OutgoingProps>
const selectClasses: Selector = createSelector(
  [
    (_, { sort: { sortDirection } }) => sortDirection,
    (_, { sort: { sortKey } }) => sortKey,
    state => state.reports.subsidies.data.klasses,
  ],
  (dir, key, items) => {
    if (key === 'classTitle') {
      return tableColumnSortClass(dir, prop(key), items);
    }
    return tableColumnSort(dir, prop(key), items);
  },
);

export default selectClasses;
